'use client';

import { useState } from 'react';
import { useSearchParams } from 'next/navigation';

import {
    TypeOurPeopleWithoutUnresolvableLinksResponse,
    TypeSimplePageLayoutWithoutUnresolvableLinksResponse,
} from '@/features/contentful/_generated';
import PageTitle from '@/features/contentful/components/PageTitle';
import LeadershispTabs from '@/containers/OurLeadership/LeadershispTabs';
import ContentLayout from '@/layouts/ContentLayout';
import ContentfulGeneric from '@/features/contentful/ContentfulGeneric/ContentfulGeneric';

const OurLeadershipPage = ({
    pageData,
    peoples,
}: {
    pageData: TypeSimplePageLayoutWithoutUnresolvableLinksResponse;
    peoples: TypeOurPeopleWithoutUnresolvableLinksResponse[];
}) => {
    const searchParams = useSearchParams();
    const [isModalOpen, setIsModalOpen] = useState(() => searchParams.has('id'));

    return (
        <>
            <ContentLayout>
                <section>
                    <div className="tw-pt-[50px]">
                        <PageTitle
                            heroComponent={pageData.fields.heroComponent}
                            hidePreview={isModalOpen}
                        />
                    </div>
                </section>

                <section className=" tw-px-0">
                    <LeadershispTabs
                        peoples={peoples}
                        isModalOpen={isModalOpen}
                        setIsModalOpen={setIsModalOpen}
                    />
                </section>
            </ContentLayout>
            <div className="tw-mt-10">
                <ContentfulGeneric mainBody={pageData?.fields.mainBody} />
            </div>
        </>
    );
};

export default OurLeadershipPage;
